import {
  fetchAll,
  fetchFiltered,
  addCauseOfMaintance,
  show,
  edit,
} from "@/api/causeofmaintance";

const state = {
  all: [],
  isLoading: false,
  causeOfMaintanceById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const causeOfMaintance = await show(id);
      commit("setCauseOfMaintanceById", causeOfMaintance);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const causeOfMaintances = await fetchAll();
      commit("setAll", causeOfMaintances);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const causeOfMaintances = await fetchFiltered(queriesParams);
      commit("setAll", causeOfMaintances);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async create({ dispatch, commit }, data) {
    try {
      commit("setLoading", true);

      await addCauseOfMaintance(data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async edit({ dispatch, commit }, { id, data }) {
    try {
      commit("setLoading", true);

      await edit(id, data);

      return true;
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },
};

const mutations = {
  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.causeOfMaintanceById = null;
  },

  setAll(state, causeOfMaintances) {
    state.all = causeOfMaintances;
  },

  setCauseOfMaintanceById(state, causeOfMaintance) {
    state.causeOfMaintanceById = {
      id: causeOfMaintance.id,
      name: causeOfMaintance.name,
      isActive: causeOfMaintance.isActive,
    };
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
